import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const razorpaySpotGoldOrderApi = createAsyncThunk('razorpayPostOrder', async (payload) => {
    const response = await axiosInstance.post('/merchant/order/create2',payload);
    return response.data;
});

const razorpaySpotGoldOrderSlice = createSlice({
    name: "razorpayPostOrder",
    initialState: {
        data: [],
        errors: [],
        loading: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(razorpaySpotGoldOrderApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(razorpaySpotGoldOrderApi.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(razorpaySpotGoldOrderApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.loading = false;
            });
    }
});

export default razorpaySpotGoldOrderSlice.reducer;
